export default __webpack_public_path__ + "static/media/company_card_icon.b137427b.svg";